/* tslint:disable */
/* eslint-disable */
/**
 * 
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { Day } from './Day';
import {
    DayFromJSON,
    DayFromJSONTyped,
    DayToJSON,
} from './Day';
import type { Value1 } from './Value1';
import {
    Value1FromJSON,
    Value1FromJSONTyped,
    Value1ToJSON,
} from './Value1';

/**
 * 
 * @export
 * @interface ControlEntityStatsByDayResponse
 */
export interface ControlEntityStatsByDayResponse {
    /**
     * 
     * @type {Day}
     * @memberof ControlEntityStatsByDayResponse
     */
    day?: Day;
    /**
     * 
     * @type {Value1}
     * @memberof ControlEntityStatsByDayResponse
     */
    value?: Value1;
    /**
     * 
     * @type {{ [key: string]: any; }}
     * @memberof ControlEntityStatsByDayResponse
     */
    data?: { [key: string]: any; };
}

/**
 * Check if a given object implements the ControlEntityStatsByDayResponse interface.
 */
export function instanceOfControlEntityStatsByDayResponse(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function ControlEntityStatsByDayResponseFromJSON(json: any): ControlEntityStatsByDayResponse {
    return ControlEntityStatsByDayResponseFromJSONTyped(json, false);
}

export function ControlEntityStatsByDayResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): ControlEntityStatsByDayResponse {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'day': !exists(json, 'day') ? undefined : DayFromJSON(json['day']),
        'value': !exists(json, 'value') ? undefined : Value1FromJSON(json['value']),
        'data': !exists(json, 'data') ? undefined : json['data'],
    };
}

export function ControlEntityStatsByDayResponseToJSON(value?: ControlEntityStatsByDayResponse | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'day': DayToJSON(value.day),
        'value': Value1ToJSON(value.value),
        'data': value.data,
    };
}

